import Vue from 'vue'
import router from './router'
import store from './store'
import AppComponent from './App'
import './plugins/element.js'
import './plugins/masonry.js'
import './plugins/axios.js' // todo use a factory
import './plugins/helpers.js'
import { loadParams } from './lib/utils'
import { API_HOST, APP_VERSION } from './constants'

console.log('Iframe View', APP_VERSION, { // eslint-ignore-line
  apiHost: API_HOST
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(AppComponent)
}).$mount('#app')

// if we are not in the callback view, we start normal page flow
if (window.location.pathname !== '/login/callback') {
  // redirect to a "waiting room" with spinner and fancy waiting and these things :D
  if (router.currentRoute.name !== 'loading') {
    router.push({ name: 'loading' })
  }

  // load the parameters from the raw url
  loadParams()

    // define the state for step execution
    .then(params => store.dispatch('steps/setStepState', params))

    // start the step execution flow
    .then(() => store.dispatch('steps/execute'))

    // catch all errors and pass it to the error view
    .catch(error => {
      router.push({ name: 'failure', params: { error } })
    })
}
